import _ from 'lodash';
import { getExternalApi, getMethodUrl, blob2Base64, timerPromise, proxyDownload } from 'app-core/Data';
import auth from 'auth';
import axios from 'axios';
import { unzip } from 'unzipit';
import { saveAs } from 'file-saver';

const downloadedDataCache = {};

async function findMedia(adjectives, opts) {
	if (!adjectives) return;
	opts = opts || {};
	const type = opts.type || 'audio';
	const aimLength = parseInt(opts.aimLength || 0);

	const result = await getExternalApi('Media/Find', `adjectives=${adjectives}&targetLength=${aimLength}&type=${type}`);
	if (__DEBUG__)
		console.debug('Find media', { result });

	return _.orderBy(result.filter(f => !aimLength || f.Length >= aimLength), f => f.Length);
}

async function downloadMedia(media, opts) {
	if (downloadedDataCache[media.Id]) {
		if (__DEBUG__)
			console.debug('Get media from cache', { media, opts });
		return opts?.asBlob ? downloadedDataCache[media.Id]?.blob : downloadedDataCache[media.Id]?.base64;
	}

	const envato = false;

	if (!envato) {
		const data = (await axios.get(media.Url, { responseType: 'blob', onProgress: opts?.onProgress }))?.data;

		const base64 = await blob2Base64(data);
		downloadedDataCache[media.Id] = { data, base64 };

		
		return opts?.asBlob ? data : base64;
	}

	const url = await retry(async () => await getExternalApi('media/GetDownloadUrl', `itemId=${media.Id}`), 1, 15000);
	if (!url || url?.Success === false) return null;

	const zipBlob = await proxyDownload(url, { responseType: 'blob', onProgress: opts?.onProgress });

	if (__DEBUG__) {
		console.debug('Zip downloaded. Unzipping.');
		console.time('Unzipped');
	}

	const { entries } = await unzip(zipBlob);

	if (__DEBUG__) {
		console.timeEnd('Unzipped');
	}

	const sortedEntries = _.orderBy(Object.keys(entries), [
		f => f?.endsWith('mp3') ? 0 : (f?.endsWith('ogg') ? 1 : (f?.endsWith('wav') ? 2 : 3)), 
		f => entries[f]?.size
	], ['asc', 'desc']);
	const resultEntry = sortedEntries[0];

	if (resultEntry) {
		const blob = await entries[resultEntry].blob(resultEntry?.endsWith('mp3') ? 'audio/mp3' : (resultEntry?.endsWith('ogg') ? 'audio/ogg' : (resultEntry?.endsWith('wav') ? 'audio/wav' : 'audio')));

		if (__DEBUG__)
			console.debug('Result blob', { blob });

		const base64 = await blob2Base64(blob);
		downloadedDataCache[media.Id] = { blob, base64 };

		if (__DEBUG__) {
			//saveAs(zipBlob, `${media.Id}.zip`);
		}
		return opts?.asBlob ? blob : base64;
	}
}

async function retry(func, count, timeout) {
	count = count || 1;
	let res = false;
	while (!res && count > 0) 
		try {
			const result = await func();
			if (result?.Success === false ) {
				if (timeout) await new Promise(res => setTimeout(() => res(), timeout));
				continue;
			}
			res = true;
			return result;
		} catch {
			if (timeout) await new Promise(res => setTimeout(() => res(), timeout));
		}
		finally {
			count--;
		}
}

if (__DEBUG__)
	window.retry = retry;

export {
	findMedia,
	downloadMedia
}

export default {
	findMedia,
	downloadMedia
};
